<template>
    <div class="dialog">
        <van-overlay :show="infoShow">
            <div class="dialog_box">
                <img src="@/assets/images/test-center/close.png" @click="goback" class="dialog_box_close" />
                <p>{{infoMsg}}</p>
                <div class="next" @click="next">确认</div>
            </div>
            
        </van-overlay>
    </div>
</template>
<script>
export default {
    name: "dialog-box",
    props:['infoShow','infoMsg'],
    data () {
        return {

        }
    },
    methods: {
        goback() {
            this.$emit('goback');
        },
        next() {
            this.$emit('next');
        }
    }

}
</script>
<style lang="scss" scoped>
.van-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    .dialog_box {
        width: 315px;
        height: 183px;
        background: #FFFFFF;
        border-radius: 16px;
        position: relative;
        overflow: hidden;
        .dialog_box_close {
            position: absolute;
            right: 15px;
            top: 15px;
            height: 12px;
            width: 12px;
        }
        p {
            width: 255px;
            margin-left: 30px;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
            margin-top: 45px;
        }
    }
    .next {
        position: absolute;
        bottom: 0;
        width: 315px;
        height: 50px;
        background: #FF8400;
        line-height: 50px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
    }
}
</style>